export const STR = {
  en: {
    orderOnline: "Order Online",
    dinein: "Dine-in Menu",
    delivery: "Takeaway / Home Delivery",
    browseNote: "Browsing our table menu — switch to Takeaway / Home Delivery to place an order.",
    searchPh: "Search for dishes (e.g. Biryani, Waffle, Dim Sum)...",
    resultsFor: (q) => `Results for "${q}"`,
    noResults: (q) => `No dishes found for "${q}"`,
    add: "ADD",
    soldOut: "Sold Out",
    veg: "Pure Veg",
    nonveg: "Non-Veg",
    items: "items",
    yourCart: "Your Cart",
    subtotal: "Subtotal",
    gst: "GST (5%)",
    total: "Total",
    deliveryDetails: "Delivery Details",
    yourName: "Your Name",
    namePh: "Full name",
    phone: "Phone",
    phonePh: "10-digit mobile number",
    address: "Delivery Address",
    addressPh: "House / street / landmark, Dumka",
    payUpi: "Pay via UPI",
    upiNote: "Scan the QR or pay from any UPI app, then enter your transaction reference (UTR) below.",
    utrPh: "Enter UTR / transaction reference no.",
    utrHelp: "Find the 12-digit UTR in your UPI app's payment success screen.",
    payBtn: (t) => `Pay ₹${t} via GPay / PhonePe / Paytm`,
    upiOpens: (t) => `Opens your UPI app with ₹${t} pre-filled to THE SWEET SPOT SAVOURIES — just enter your UPI PIN.`,
    checkout: (t) => `Proceed to Checkout • ₹${t}`,
    placing: "Placing Order...",
    orderPlaced: "Order Placed!",
    orderId: "Order ID",
    teamConfirm: "our team will confirm shortly.",
    payVerify: "Payment reference received — we will verify it on HDFC SmartHub Vyapar.",
    callUpdates: "for updates",
    placeAnother: "Place Another Order",
    viewCart: "View Cart",
    homeMenuTitle: "Explore Our Menu",
    homeMenuSub: "Our full digital menu — live prices, straight from the kitchen",
    more: "Read more",
    less: "View less",
    inCart: "in cart",
    extraCheese: "Extra Cheese",
    chooseSize: "Choose size",
  },
  hi: {
    orderOnline: "ऑनलाइन ऑर्डर करें",
    dinein: "डाइन-इन मेनू",
    delivery: "टेकअवे / होम डिलीवरी",
    browseNote: "आप टेबल मेनू देख रहे हैं — ऑर्डर करने के लिए टेकअवे / होम डिलीवरी चुनें।",
    searchPh: "डिश खोजें (जैसे बिरयानी, वफ़ल, डिम सम)...",
    resultsFor: (q) => `"${q}" के परिणाम`,
    noResults: (q) => `"${q}" के लिए कोई डिश नहीं मिली`,
    add: "जोड़ें",
    soldOut: "स्टॉक खत्म",
    veg: "शुद्ध शाकाहारी",
    nonveg: "मांसाहारी",
    items: "आइटम",
    yourCart: "आपकी कार्ट",
    subtotal: "उप-योग",
    gst: "जीएसटी (5%)",
    total: "कुल",
    deliveryDetails: "डिलीवरी विवरण",
    yourName: "आपका नाम",
    namePh: "पूरा नाम",
    phone: "फ़ोन",
    phonePh: "10 अंकों का मोबाइल नंबर",
    address: "डिलीवरी पता",
    addressPh: "मकान / गली / लैंडमार्क, दुमका",
    payUpi: "यूपीआई से भुगतान करें",
    upiNote: "QR स्कैन करें या किसी भी UPI ऐप से भुगतान करें, फिर नीचे UTR दर्ज करें।",
    utrPh: "UTR / ट्रांज़ैक्शन रेफरेंस नंबर दर्ज करें",
    utrHelp: "12 अंकों का UTR आपके UPI ऐप की पेमेंट सफलता स्क्रीन पर मिलता है।",
    payBtn: (t) => `GPay / PhonePe / Paytm से ₹${t} भुगतान करें`,
    upiOpens: (t) => `आपका UPI ऐप ₹${t} के साथ खुलेगा — बस अपना UPI PIN डालें।`,
    checkout: (t) => `ऑर्डर करें • ₹${t}`,
    placing: "ऑर्डर हो रहा है...",
    orderPlaced: "ऑर्डर हो गया!",
    orderId: "ऑर्डर आईडी",
    teamConfirm: "हमारी टीम जल्द पुष्टि करेगी।",
    payVerify: "भुगतान रेफरेंस मिल गया — हम HDFC SmartHub Vyapar पर सत्यापित करेंगे।",
    callUpdates: "पर अपडेट के लिए कॉल करें",
    placeAnother: "एक और ऑर्डर करें",
    viewCart: "कार्ट देखें",
    homeMenuTitle: "हमारा मेनू देखें",
    homeMenuSub: "पूरा डिजिटल मेनू — लाइव कीमतें, सीधे रसोई से",
    more: "और पढ़ें",
    less: "छोटा करें",
    inCart: "कार्ट में",
    extraCheese: "एक्स्ट्रा चीज़",
    chooseSize: "साइज़ चुनें",
  },
};

export const CAT_HI = {
  best: "बेस्टसेलर",
  dimsum: "डिम सम",
  sushi: "सुशी",
  bao: "बाओ",
  biryani: "दम बिरयानी",
  main: "मेन कोर्स",
  breads: "ब्रेड",
  south: "साउथ इंडियन",
  pizza: "पिज़्ज़ा और पास्ता",
  waffles: "वफ़ल और शेक",
};

export const ITEM_HI = {
  "umami-cloud-dimsum": "उमामी क्लाउड डिमसम",
  "spincorn-cheese-dimsum": "स्पिनकॉर्न चीज़ डिमसम",
  "mushroom-cream-cheese-dimsum": "मशरूम क्रीम चीज़ डिमसम",
  "crispy-mushroom-gyoza": "क्रिस्पी मशरूम ग्योज़ा",
  "crystal-garden-dumplings": "क्रिस्टल गार्डन डंपलिंग्स",
  "spicy-shiitake-roll": "स्पाइसी शिटाके रोल",
  "avocado-cream-cheese-roll": "एवोकाडो क्रीम चीज़ रोल",
  "california-roll": "कैलिफ़ोर्निया रोल",
  "cream-cheese-sesame-roll": "क्रीम चीज़ तिल रोल",
  "thai-bao": "थाई बाओ",
  "chilli-paneer-bao": "चिली पनीर बाओ",
  "mushroom-bao": "मशरूम बाओ",
  "hyderabadi-veg-biryani": "हैदराबादी वेज बिरयानी",
  "kolkata-veg-biryani": "कोलकाता वेज बिरयानी",
  "lucknowi-veg-biryani": "लखनवी वेज बिरयानी",
  "paneer-biryani": "पनीर बिरयानी",
  "mushroom-biryani": "मशरूम बिरयानी",
  "bloomora-special-biryani": "ब्लूमोरा स्पेशल बिरयानी",
  "paneer-butter-masala": "पनीर बटर मसाला",
  "palak-paneer": "पालक पनीर",
  "kadhai-paneer": "कढ़ाई पनीर",
  "paneer-korma": "पनीर कोरमा",
  "malai-kofta": "मलाई कोफ़्ता",
  "matar-paneer": "मटर पनीर",
  "mushroom-masala": "मशरूम मसाला",
  "kaju-malai-methi": "काजू मलाई मेथी",
  "smoked-dal-makhani": "स्मोक्ड दाल मखनी",
  "chole-masala": "छोले मसाला",
  "tandoori-roti": "तंदूरी रोटी (बटर)",
  "butter-naan": "बटर नान",
  "garlic-naan": "गार्लिक नान",
  "laccha-paratha": "लच्छा पराठा",
  "paneer-kulcha": "पनीर कुलचा",
  "cheese-garlic-toast": "चीज़ गार्लिक टोस्ट",
  "veg-grilled-cheese-corn": "वेज ग्रिल्ड चीज़ कॉर्न सैंडविच",
  "veg-grilled-cheese-paneer": "वेज ग्रिल्ड चीज़ पनीर सैंडविच",
  "masala-dosa": "मसाला डोसा",
  "plain-dosa": "प्लेन डोसा",
  "mysore-dosa": "मैसूर डोसा",
  "ghee-roast-dosa": "घी रोस्ट डोसा",
  "cheese-masala-dosa": "चीज़ मसाला डोसा",
  "bloomora-special-dosa": "ब्लूमोरा स्पेशल डोसा",
  "plain-idli": "प्लेन इडली",
  "sambar-vada": "सांबर वड़ा",
  "masala-uttapam": "मसाला उत्तपम",
  "margherita-pizza": "क्लासिक मार्गेरिटा पिज़्ज़ा",
  "farm-fresh-veg-pizza": "फ़ार्म फ्रेश वेज पिज़्ज़ा",
  "spicy-cottage-cheese-pizza": "स्पाइसी पनीर पिज़्ज़ा",
  "smoked-paneer-mushroom-pizza": "स्मोक्ड पनीर मशरूम पिज़्ज़ा",
  "alfredo-pasta": "अल्फ्रेडो पास्ता",
  "arrabiata-pasta": "अर्राबियाटा पास्ता",
  "aglio-olio-pasta": "आग्लियो ओलियो पास्ता",
  "biscoff-waffle": "बिस्कॉफ वफ़ल",
  "belgian-triple-chocolate-waffle": "बेल्जियन ट्रिपल चॉकलेट वफ़ल",
  "blueberry-cheesecake-waffle": "ब्लूबेरी चीज़केक वफ़ल",
  "nutella-cheesecake-waffle": "न्यूटेला चीज़केक वफ़ल",
  "kitkat-waffle": "किटकैट वफ़ल",
  "butterscotch-shake": "बटरस्कॉच शेक",
  "chocolate-shake": "चॉकलेट शेक",
  "oreo-shake": "ओरियो शेक",
  "kitkat-shake": "किटकैट शेक",
  "dry-fruit-shake": "ड्राई फ्रूट शेक",
  "vanilla-shake": "वैनिला शेक",
  "nutella-milkshake": "न्यूटेला मिल्कशेक",
  "strawberry-shake": "स्ट्रॉबेरी शेक",
  "hot-coffee": "हॉट कॉफ़ी",
  "cold-coffee": "कोल्ड कॉफ़ी",
  "cold-coffee-icecream": "कोल्ड कॉफ़ी विद आइसक्रीम",
};
